(function(){
 'use strict';if(window.BuceCartRails)return;
 const mounted=new WeakMap(),live=new Map(),positions=new Map();let serial=0;
 function mount(root=document){
  live.forEach((observer,track)=>{if(!track.isConnected){observer.disconnect();live.delete(track);mounted.delete(track);}});
  const tracks=root.matches?.('[data-buce-rail-track]')?[root]:root.querySelectorAll('[data-buce-rail-track]');
  tracks.forEach(track=>{
   if(mounted.has(track)){mounted.get(track)();return;}
   const group=track.closest('[data-buce-cart-rail]'),meter=group?.querySelector('[data-buce-rail-meter]'),heading=group?.querySelector('h4');
   const key=(track.closest('#t4s-mini_cart')?'drawer:':'page:')+group?.dataset.buceCartRail;let restored=false;
   if(heading){heading.id='buce-cart-rail-'+(++serial);group.setAttribute('aria-labelledby',heading.id);}
   function update(){
    if(!meter)return;const range=track.scrollWidth-track.clientWidth;meter.hidden=range<=2||track.clientWidth===0;
    if(range>2&&track.clientWidth>0){if(!restored){restored=true;track.scrollLeft=Math.min(positions.get(key)||0,range);}positions.set(key,Math.abs(track.scrollLeft));if(track.hasAttribute('data-buce-rail-focus')){track.removeAttribute('data-buce-rail-focus');track.focus({preventScroll:true});}}
    const position=range>0?Math.min(1,Math.abs(track.scrollLeft)/range):0,thumb=track.scrollWidth?Math.max(12,track.clientWidth*100/track.scrollWidth):100;
    meter.style.setProperty('--buce-rail-thumb',thumb+'%');meter.style.setProperty('--buce-rail-left',position*(100-thumb)+'%');meter.setAttribute('aria-valuenow',String(Math.round(position*100)));
   }
   track.addEventListener('scroll',update,{passive:true});
   track.addEventListener('keydown',event=>{
    if(event.target!==track||!['ArrowRight','ArrowLeft','Home','End'].includes(event.key))return;
    event.preventDefault();const step=(track.firstElementChild?.getBoundingClientRect().width||90)+8;
    const left=event.key==='Home'?0:event.key==='End'?track.scrollWidth:track.scrollLeft+(event.key==='ArrowLeft'?-step:step);
    track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   });
   const observer=new ResizeObserver(update);observer.observe(track);live.set(track,observer);mounted.set(track,update);update();
  });
 }
 window.BuceCartRails={mount};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(),{once:true});else mount();
 document.addEventListener('shopify:section:load',()=>mount());
})();
